export default __webpack_public_path__ + "static/media/60694C0E-9876-495C-99A1-0B38DC2DFBEB_1_105_c.226910b5.jpeg";